import {
  apiCallWithAuth,
  apiCallWithAuthWithReturn,
  handleResponseErrorData,
  handleResponseErrorDataReturn,
  processApiResponse,
} from "../utils/commonUtils";
import { getToken } from "../utils/tokenUtils";
import { jwtDecode } from "jwt-decode";

export const createAppointmentWithoutOTP = async (
  patientData,
  doctorId,
  clinicId,
  appointmentDate,
  status
) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/appointments/createAppointmentWithoutOTP`;
    const data = JSON.stringify({
      patientData,
      doctor_id: doctorId,
      clinic_id: clinicId,
      appointmentDate,
      status,
    });
    return await apiCallWithAuthWithReturn(url, "POST", data, {}, null);
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const fetchAppointments = async (doctorIdData, filters) => {
  try {
    const { startDate, endDate } = filters;
    const token = await getToken();
    const decodedToken = jwtDecode(token); // Assuming `jwtDecode` and `getToken` are properly imported/utilized
    const clinicId = decodedToken?.clinic_ids[0]; // Assuming there's always at least one clinic_id
    let doctorId =
      doctorIdData != undefined ? doctorIdData : decodedToken.doctor_id;
    const url = `${process.env.REACT_APP_API_URL}/appointments/getAppointments`;
    const data = JSON.stringify({
      doctorId: doctorId,
      clinicId,
      startDate,
      endDate,
    });
    return await apiCallWithAuthWithReturn(url, "POST", data, {}, null);
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const fetchAllAppointments = async (clinicId, filters) => {
  try {
    const { startDate, endDate } = filters;
    const data = JSON.stringify({ clinicId, startDate, endDate });
    const url = `${process.env.REACT_APP_API_URL}/appointments/getAllAppointments`;
    return await apiCallWithAuth(url, "POST", data, {}, null);
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const checkClinicProfileAddress = async (userId) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/init/checkProfile/address`;
    const data = JSON.stringify({ user_id: userId });
    const responseData = await apiCallWithAuthWithReturn(
      url,
      "POST",
      data,
      {
        "Content-Type": "application/json",
      },
      null
    );

    const addressDetails = responseData.data.addressDetails;
    return addressDetails;
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const getNextPatient = async (userId) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/appointments/next`;
    const data = JSON.stringify({ userId });
    return await apiCallWithAuth(url, "POST", data, {}, null);
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const checkInPatient = async (appointmentId) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/appointments/checkin`;
    const data = JSON.stringify({ appointmentId });
    return await apiCallWithAuth(url, "POST", data, {}, null);
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const fetchPrescriptionsForDoctor = async ({
  clinic_id,
  doctor_id,
  timestamp,
}) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/prescription/fetchPrescriptionsForDoctor`;
    const data = JSON.stringify({
      clinic_id,
      doctor_id,
      timestamp: timestamp ? timestamp.toISOString() : undefined,
    });
    return await apiCallWithAuthWithReturn(
      url,
      "POST",
      data,
      {
        "Content-Type": "application/json",
      },
      null
    );
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const fetchPrescriptionsForClinic = async ({ clinic_id, filters }) => {
  try {
    const { startDate, endDate } = filters;
    const data = JSON.stringify({ clinic_id, startDate, endDate });
    const url = `${process.env.REACT_APP_API_URL}/prescription/fetchPrescriptionsForClinic`;
    return await apiCallWithAuthWithReturn(
      url,
      "POST",
      data,
      {
        "Content-Type": "application/json",
      },
      null
    );
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const checkInAppointment = async (appointmentId) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/appointments/checkInAppointment`;
    const data = JSON.stringify({ appointmentId });
    return await apiCallWithAuth(url, "POST", data, {}, null);
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const changeDoctorForAppointment = async (
  appointmentId,
  newDoctorId
) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/appointments/changeDoctorForAppointment`;
    const data = JSON.stringify({ appointmentId, newDoctorId });
    return await apiCallWithAuth(url, "POST", data, {}, null);
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const updatePatientBasicDetails = async (
  patientId,
  firstName,
  lastName,
  dateOfBirth,
  gender,
  phoneNumber
) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/auth/update-basic-details`;
    const data = JSON.stringify({
      patientId,
      firstName,
      lastName,
      dateOfBirth,
      gender,
      phoneNumber,
    });
    return await apiCallWithAuthWithReturn(url, "POST", data, {}, null);
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const cancelAppointment = async (appointmentId) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/appointments/cancelAppointment`;
    const data = JSON.stringify({ appointmentId });
    return await apiCallWithAuth(url, "POST", data, {}, null);
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const getPatientDetails = async (patientId) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/auth/getPatientUsingPatientId`;
    const data = JSON.stringify({ patientId });
    return await apiCallWithAuthWithReturn(url, "POST", data, {}, null);
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};
export const getPatientDetailsWithContactInfo = async (patientId) => {
  try {
    const res = await getPatientDetails(patientId);
    console.log("dataurl01", res);

    if (!res.status) {
      console.error("Failed to fetch patient details");
      return {
        patient: null,
        primary_phone_number: "",
        patient_contact_info_id: "",
        userDetails: { contact_info_id: "" },
      }; // Return null patient data with blank primary phone number and contact info ids
    }
    const patientData = res.data;

    // Ensure patientData has expected structure and content
    if (
      !patientData ||
      !patientData.patient ||
      !patientData.patient.userDetails.contact_info_id
    ) {
      console.error("Patient data is missing or invalid");
      return {
        ...patientData,
        primary_phone_number: "",
        patient_contact_info_id: "",
        userDetails: { contact_info_id: "" },
      };
    }

    const contactInfoId = patientData.patient.userDetails.contact_info_id;
    console.log("dataurl03", contactInfoId);

    const getContactInfoUrl = `${process.env.REACT_APP_API_URL}/auth/getContactInfo`;
    const contactInfoData = await apiCallWithAuthWithReturn(
      getContactInfoUrl,
      "POST",
      JSON.stringify({ contactInfoId }),
      {},
      null
    );

    // Check if contactInfoData is valid and has primary_phone_number
    const primaryPhoneNumber =
      contactInfoData &&
      contactInfoData.contactInfo &&
      contactInfoData.contactInfo.primary_phone_number
        ? contactInfoData.contactInfo.primary_phone_number
        : "";

    // Combine patient details with primary_phone_number and return
    return {
      ...patientData,
      primary_phone_number: primaryPhoneNumber,
      patient_contact_info_id: patientData.patient.patient_contact_info_id,
      userDetails: {
        ...patientData.patient.userDetails,
        contact_info_id: contactInfoId,
      },
    };
  } catch (error) {
    console.error("Error fetching patient details:", error);
    return {
      patient: null,
      primary_phone_number: "",
      patient_contact_info_id: "",
      userDetails: { contact_info_id: "" },
    }; // Return null patient data with blank primary phone number and contact info ids in case of error
  }
};

// Fetch prescriptions for a patient
export const fetchPrescriptionsForPatient = async (patientId, clinicId) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/prescription/fetchPrescriptionsForPatient`;
    const data = JSON.stringify({ patient_id: patientId, clinic_id: clinicId });
    return await apiCallWithAuthWithReturn(
      url,
      "POST",
      data,
      {
        "Content-Type": "application/json",
      },
      null
    );
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

// Fetch bills for a patient
export const fetchBillsForPatient = async (patientId, clinicId) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/invoices/fetchBillsForPatient`;
    const data = JSON.stringify({ patient_id: patientId, clinic_id: clinicId });
    return await apiCallWithAuthWithReturn(
      url,
      "POST",
      data,
      {
        "Content-Type": "application/json",
      },
      null
    );
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

// Fetch bills for a clinic
export const fetchInvoiceDataByClinicId = async (clinicId, filters) => {
  try {
    const { startDate, endDate, billstatus } = filters;
    const query = `startDate=${startDate}&endDate=${endDate}&billstatus=${billstatus}`;
    const url = `${process.env.REACT_APP_API_URL}/invoices/fetchInvoiceDataByClinicId/${clinicId}?${query}`;
    return await apiCallWithAuthWithReturn(
      url,
      "GET",
      null,
      {
        "Content-Type": "application/json",
      },
      null
    );
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

// Fetch Reports for a clinic
export const fetchReportsByClinicId = async (clinicId, filters) => {
  try {
    const { startDate, endDate, doctorId } = filters;
    const query = `startDate=${startDate}&endDate=${endDate}&doctorId=${doctorId}`;
    const url = `${process.env.REACT_APP_API_URL}/invoices/fetchReportsByClinicId/${clinicId}?${query}`;
    return await apiCallWithAuthWithReturn(
      url,
      "GET",
      null,
      {
        "Content-Type": "application/json",
      },
      null
    );
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

// Fetch Payments for a clinic
export const fetchPaymentsByClinicId = async (clinicId, filters) => {
  try {
    const { startDate, endDate, paymentMethod, paymentstatus } = filters;
    const query = `startDate=${startDate}&endDate=${endDate}&paymentMethod=${paymentMethod}&paymentstatus=${paymentstatus}`;
    const url = `${process.env.REACT_APP_API_URL}/invoices/fetchPaymentsByClinicId/${clinicId}?${query}`;
    return await apiCallWithAuthWithReturn(
      url,
      "GET",
      null,
      {
        "Content-Type": "application/json",
      },
      null
    );
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

// Fetch appointments for a patient
export const fetchAppointmentsForPatient = async (patientId, clinicId) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/appointments/fetchAppointmentsForPatient`;
    const data = JSON.stringify({ patient_id: patientId, clinic_id: clinicId });
    return await apiCallWithAuthWithReturn(url, "POST", data, {}, null);
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const fetchFilesForPatient = async (patientId, clinicId) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/files/fetchFilesForPatient`;
    const data = JSON.stringify({ patient_id: patientId, clinic_id: clinicId });
    return await apiCallWithAuthWithReturn(
      url,
      "POST",
      data,
      {
        "Content-Type": "application/json",
      },
      null
    );
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const uploadFile = async (fileData) => {
  try {
    const token = await getToken();
    const url = `${process.env.REACT_APP_API_URL}/files/uploadFile`;
    const formData = fileData;
    return await apiCallWithAuthWithReturn(url, "POST", formData, {}, null, {
      removeContentType: true,
    });
  } catch (error) {
    return handleResponseErrorDataReturn(error, null);
  }
};

export const deletePrescriptionFile = async (patientId, fileId) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/files/deletePrescriptionFile`;
    const data = JSON.stringify({ patient_id: patientId, file_id: fileId });
    return await apiCallWithAuthWithReturn(
      url,
      "DELETE",
      data,
      {
        "Content-Type": "application/json",
      },
      null
    );
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

// Fetch Invoice
export const fetchInvoiceDataById = async (invoiceId) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/invoices/fetchInvoiceDataById/${invoiceId}`;
    return await apiCallWithAuthWithReturn(
      url,
      "GET",
      null,
      {
        "Content-Type": "application/json",
      },
      null
    );
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

/*
 *  used in Dashboard.js
 */
export const serviceHandleNextPatient = async (params) => {
  const { appointment_number, timestamp, clinicId, doctorId } = params;

  const body = {
    clinic_id: clinicId,
    doctor_id: doctorId,
    appointment_number: appointment_number,
    timestamp: timestamp,
  };
  // Make the API call to the nextAppointment endpoint
  try {
    const url = `${process.env.REACT_APP_API_URL}/appointments/nextAppointment`;
    const data = JSON.stringify(body);
    return await apiCallWithAuth(url, "POST", data, {}, null);
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

/*
 *
 */
export const serviceHandleAddPatientSubmit = async (params) => {
  const { name, age, gender, patientDetails, date_of_birth } = params;
  try {
    const body = {
      relatedPatientId: patientDetails.patient_id,
      firstName: name,
      lastName: "",
      age,
      date_of_birth,
      gender,
      relationType: "TODO",
      contactNumber: patientDetails.phone_number,
    };
    const url = `${process.env.REACT_APP_API_URL}/auth/addRelatedPatient`;
    const data = JSON.stringify(body);
    return await apiCallWithAuthWithReturn(url, "POST", data, {}, null);
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const serviceCreateAppointment = async (params) => {
  const { patientId, doctorId, clinicId, appointmentDate, status } = params;
  try {
    const body = {
      patientId,
      doctorId,
      clinicId,
      appointmentDate,
      status,
    };
    const url = `${process.env.REACT_APP_API_URL}/appointments/createAppointment`;
    const data = JSON.stringify(body);
    return await apiCallWithAuthWithReturn(url, "POST", data, {}, null);
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const serviceGetListOfPatientsForClinicId = async (clinicId) => {
  try {
    const body = { clinicId };
    const url = `${process.env.REACT_APP_API_URL}/auth/getListOfPatientsUsingClinicId`;
    const data = JSON.stringify(body);
    return await apiCallWithAuthWithReturn(url, "POST", data, {}, null);
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const serviceAddDoctorSubmit = async (params) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/auth/addDoctor`;
    const data = JSON.stringify(params);
    return await apiCallWithAuthWithReturn(url, "POST", data, {}, null);
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const serviceUpdateDoctor = async (doctorId, params) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/auth/updateDoctor/${doctorId}`;
    const data = JSON.stringify(params);
    return await apiCallWithAuthWithReturn(url, "PATCH", data, {}, null);
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const serviceToggleDoctorStatus = async (doctorId) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/auth/toggleDoctorStatus/${doctorId}`;
    return await apiCallWithAuthWithReturn(url, "PATCH", null, {}, null);
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const serviceFetchDoctorList = async (userId, activeOnly = false) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/auth/fetchDoctorsDetails?userId=${userId}${activeOnly ? '&activeOnly=true' : ''}`;
    const data = null;
    return await apiCallWithAuthWithReturn(url, "GET", data, {}, null);
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const serviceFetchDoctorsList = async (clinicId) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/auth/fetchDoctorsWithClinicId?clinic_id=${clinicId}`;
    return await apiCallWithAuthWithReturn(url, "GET", null, {}, null);
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const insertDoctorSlot = async (doctor_id, working_hours) => {
  try {
    let temp = { doctor_id: doctor_id, working_hours: working_hours };
    const url = `${process.env.REACT_APP_API_URL}/auth/availabletimeslots/${doctor_id}`;
    const body = JSON.stringify(temp);
    return await apiCallWithAuthWithReturn(url, "POST", body, {}, null);
  } catch (error) {
    console.error("Error inserting doctor slot:", error);
    return handleResponseErrorDataReturn(error, null);
  }
};

export const fetchEMRSettings = async (doctorId, clinicId) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/auth/getEMRSettings?doctor_id=${doctorId}&clinic_id=${clinicId}`;
    return await apiCallWithAuthWithReturn(url, "GET", null, {}, null);
  } catch (error) {
    console.error("Error fetching EMR settings:", error);
    return handleResponseErrorData(error, null);
  }
};

export const updateEMRSettings = async (formData) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/auth/updateEMRSettings`;
    // Create a headers object without setting Content-Type
    const headers = {
      // You can add other headers if needed
    };
    // Set removeContentType option to true
    const otherOption = {
      removeContentType: true,
    };
    return await apiCallWithAuthWithReturn(
      url,
      "POST",
      formData,
      headers,
      null,
      otherOption
    );
  } catch (error) {
    console.error("Error updating EMR settings:", error);
    return handleResponseErrorData(error, null);
  }
};
